var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCheckAllHorizontal = function SvgCheckAllHorizontal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 19
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#505e5f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 3V0l4 4-4 4V5H0V3zM0 13v4a1.993 1.993 0 0 0 2 2h4a1.993 1.993 0 0 0 2-2v-4a1.993 1.993 0 0 0-2-2H2a1.993 1.993 0 0 0-2 2m6 0v4H2v-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 11h-4a1.993 1.993 0 0 0-2 2v4a1.993 1.993 0 0 0 2 2h4a1.993 1.993 0 0 0 2-2v-4a1.993 1.993 0 0 0-2-2m-2.73 6.5-2.53-2.55 1.07-1.05 1.47 1.49 2.92-2.89 1.06 1.05z",
    "data-name": "sort-bool-ascending-variant"
  }))));
};
export default SvgCheckAllHorizontal;